import styles from "./mission-column.module.scss";

const MissionColumn = ({status, drag, children}) => {

    if(drag) {
        return (
            <div className={styles.column} draggable={true} id={status}
                 onDragStart={drag.dragStartHandler}
                 onDragLeave={drag.dragEndHandler}
                 onDragEnd={drag.dragEndHandler}
                 onDragOver={drag.dragOverHandler}
                 onDrop={drag.dropHandler}
            >
                <div className={styles.status}>
                    <span className={styles.statusIcon} />
                    <span className={styles.statusText}>{status}</span>
                </div>
                {children}
            </div>
        )
    }

    return (
        <div className={styles.column}>
            <div className={styles.status}>
                <span className={styles.statusIcon} />
                <span className={styles.statusText}>{status}</span>
            </div>
            {children}
        </div>
    )
}

export default MissionColumn;
